import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { useAuth0 } from '@auth0/auth0-react'

interface Profile {
  id: string
  name: string
  email: string
  status: string
  // agrega aquí los demás campos que devuelva tu API
}

interface GetProfileParams {
  page?: number
  pageSize?: number
  email?: string
  name?: string
  status?: string
}

const apiUrl = process.env.REACT_APP_API_URL;


const fetchProfiles = async (
  params: GetProfileParams,
  getAccessTokenSilently: () => Promise<string>
) => {
  const { page = 0, pageSize = 10, email, name, status = 'ALL' } = params

  // obtener token de Auth0
  const tk = await getAccessTokenSilently()

  const response = await axios.get(`${apiUrl}/api/v1/admin/profile/all`, {
    params: {
      page,
      pageSize,
      email,
      name,
      status,
    },
    headers: {
      Authorization: `Bearer ${tk}`,
    },
  })

  return response.data
}

export const useGetProfiles = (params: GetProfileParams) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0()

  return useQuery({
    queryKey: ['profiles', params],
    queryFn: () => fetchProfiles(params, getAccessTokenSilently),
    enabled: isAuthenticated, // solo corre si el usuario está autenticado
  
    retry: 1, // número de reintentos en caso de error
  })
}
